import React, { Suspense } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Navbar from "components/navbar";
import Footer from "components/footer/Footer";
import { adminRoutes } from "routes.js"; // ✅ sirf adminRoutes import
import Sidebar from "components/sidebar";

export default function Admin(props) {
  const { ...rest } = props;
  const location = useLocation();
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    const handleResize = () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  React.useEffect(() => {
    const route = adminRoutes.find(r => 
      location.pathname.includes(r.path)
    );
    if (route) setCurrentRoute(route.name);
  }, [location.pathname]);

  const getActiveNavbar = (routes) => {
    const route = routes.find(r => location.pathname.includes(r.path));
    return route ? route.secondary : false;
  };

  const getRoutes = (routes) => {
    return routes
      .filter(prop => prop.layout === "/admin")
      .map((prop, key) => (
        <Route path={prop.path} element={<prop.component />} key={key} />
      ));
  };

  document.documentElement.dir = "ltr";
  return (
    <div className="flex h-full w-full">
      <Sidebar open={open} onClose={() => setOpen(false)} routes={adminRoutes} />
      {/* Navbar & Main Content */}
      <div className="h-full w-full bg-gray-50 dark:!bg-navy-900">
        {/* Main Content */}
        <main
          className={`mx-[12px] h-full flex-none transition-all md:pr-2 xl:ml-[313px]`}
        >
          {/* Routes */}
          <div className="h-full">
            <Navbar
              onOpenSidenav={() => setOpen(true)}
              logoText={"Horizon UI Tailwind React"}
              brandText={currentRoute}
              secondary={getActiveNavbar(adminRoutes)} 
              {...rest}
            />
            <div className="mx-auto mb-auto h-full min-h-[84vh] pt-5 px-2 md:pr-2">
              <Suspense fallback={<div className="flex h-full items-center justify-center"><div className="text-xl font-medium text-navy-700 dark:text-white">Loading...</div></div>}>
                <Routes>
                  {getRoutes(adminRoutes)}

                  <Route
                    path="/"
                    element={<Navigate to="/admin/default" replace />}
                  />
                </Routes>
              </Suspense>
            </div>
            <div className="p-3">
              <Footer />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
